// These are in a separate file because they're used in JS as well,
// and putting them in tailwind.config.js as separate exports
// doesn't work well with tree-shaking

export const screens = {
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1400px',
}